import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import {
  AgentNotifications,
  ClientAuthenticationModal,
  FaximoSendFaxErrors,
  FollowupMessageErrors,
  Logout,
  MedicationFollowupNotificationPanelState,
  Notification,
  NotificationPopoverState,
  NotificationSettings,
  RenewClientCertModal,
  TelemedicineAppointments,
  TwoFactorAuthenticationModal,
  UberDeliveryNotifications,
  YakumaruRequestErrorNotifications,
} from './types';

export const medicationFollowupNotificationPanelState =
  atomWithReset<MedicationFollowupNotificationPanelState>({
    page: 1,
    perPage: 6,
    totalPage: 1,
    totalCount: 0,
  });

export const notificationPopoverState = atomWithReset<NotificationPopoverState>({
  isOpen: false,
});

export const logoutState = atom<Logout>({
  isLogout: false,
});

export const notificationState = atom<Notification>({
  followupCount: 0,
  receptionCount: 0,
  entryCount: 0,
  medicineNoteCount: 0,
});

export const notificationSettingsState = atom<NotificationSettings>({
  isLightPlan: false,
  isFollowupEnabled: false,
  isOnlineEnabled: false,
});

export const telemedicineAppointmentsState = atom<TelemedicineAppointments>({
  isEnabled: true,
  appointments: [],
});

export const twoFactorAuthModalState = atomWithReset<TwoFactorAuthenticationModal>({
  isOpen: false,
  isReset: false,
  currentPanel: 'introduction',
  otpSecretId: null,
  qrCodeData: null,
});

export const faximoSendFaxErrorState = atom<FaximoSendFaxErrors>({
  loaded: false,
  notifications: [],
});

export const clientAuthenticationModalState = atomWithReset<ClientAuthenticationModal>({
  isClosed: false,
});

export const followupMessageErrorState = atom<FollowupMessageErrors>({
  loaded: false,
  notifications: [],
});

export const uberDeliveryNotificationsState = atom<UberDeliveryNotifications>({
  loaded: false,
  notifications: [],
  needPlaySoundNotificationCount: 0,
});

export const agentNotificationsState = atom<AgentNotifications>({
  loaded: false,
  notifications: [],
});

export const yakumaruRequestErrorNotificationsState = atom<YakumaruRequestErrorNotifications>({
  loaded: false,
  notifications: [],
});

export const renewClientCertModalState = atom<RenewClientCertModal>({
  isOpen: false,
  isClosed: false,
  isAdmin: false,
  isCompanyAdmin: false,
  renewableTarget: null,
  clientCert: null,
  practitionerId: '',
});
